<template>
  <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <base-card
      :title="isEntryMode ? 'Add Size' : 'Update Size'"
      :v-card-text-class="'pa-4'"
    >
      <v-form @submit.prevent="submit" ref="SizeSetup">
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Name"
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="name.value.value"
              :error-messages="name.errorMessage.value"
              clearable
            >
              <template #label>
                Name <span class="text-red-accent-4">*</span>
              </template>
            </v-text-field>

            <v-text-field
              label="Remarks (Optional)"
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="remarks.value.value"
              :error-messages="remarks.errorMessage.value"
              clearable
            ></v-text-field>

            <v-checkbox
              label="Active"
              v-model="status.value.value"
              :error-messages="status.errorMessage.value"
              density="compact"
              variant="outlined"
              hide-details
              single-line
              color="primary"
              value="1"
            ></v-checkbox>
            <input v-model="size_id.value.value" type="hidden" />
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="justify-end">
            <v-btn
              class="bg-red"
              variant="flat"
              type="reset"
              @click="closeDialog"
              >Close</v-btn
            >
            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
              {{ isEntryMode ? "Save" : "Update" }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-form>
    </base-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";
import baseCard from "@/components/utils/baseCard.vue";

export default {
  name: "SizeSetup",
  components: {
    baseCard
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        name: "",
        remarks: "",
        status: "1",
        size_id: null,
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: "",
      loading: false,
      isEntryMode: true,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || "", false);
        this.remarks.setValue(newData.remarks || "", false);
        this.status.setValue(String(newData.status) || "1", false);
        this.size_id.setValue(newData.id || "", false);
      },
    },
  },
  created() {},
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        name: yup.string().min(1).max(50).required().trim().label("Name"),
        remarks: yup.string().max(250).nullable().trim().label("Remarks"),
      }),
    });

    const name = useField("name");
    const remarks = useField("remarks");
    const status = useField("status");
    const size_id = useField("size_id");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      store.dispatch("saveUpdateSize", values)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          loading.value = true;
          store
            .dispatch("getSizeList")
            .then((data) => {
              loading.value = false;
            })
            .catch((error) => {
              loading.value = false;
              toast.error(error.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      name,
      remarks,
      status,
      errorMessages,
      size_id,
      resetForm,
      loading,
    };
  },
  mounted() {},
};
</script>
